import { useMediaQuery } from '@myn/mui';

const useViewportWidth = () => {
  const isDesktopWidth = useMediaQuery('(min-width: 1440px)');
  const isLaptopWidth = useMediaQuery(
    '(min-width: 1280px) and (max-width: 1440px)',
  );
  const isTabletWidth = useMediaQuery('(max-width: 1028px)');

  return {
    isDesktopWidth,
    isLaptopWidth,
    isTabletWidth,
  };
};

export default useViewportWidth;
